<div class="top">
    <div class="heading">
        <span>EDIT ASSET DETAILS</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
        close
    </i>
</div>

<div class="form-wrapper">
    <form [formGroup]="form" (ngSubmit)="openConfirmModal()">
        <div class="form-fields">
            <div class="row g-3">
              <div class="col-md-6 field">
                    <label>
                        PLATE NUMBER
                    </label>

                    <input type="text" placeholder="eg ABJ420FT" class="form-control mt-0" formControlName="plateNumber"
                        maxlength="100">
                    <app-error-message [form]="form" controlName="plateNumber"
                        [showErrorMessage]="showErrorMessages"></app-error-message>

                </div>

                <div class="col-md-6 field">
                    <label class="required">
                        ROUTE 
                    </label>

                    <ng-select [items]="transportsList" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
                        [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
                        formControlName="route" class="ng-select control role-select">

                    </ng-select>


                    <app-error-message [form]="form" controlName="transport"
                        [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>

                <div class="col-md-6 field">
                    <label class="required">
                        TRANSPORT ROUTE
                    </label>


                    <ng-select [items]="transportRoutesList" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
                        [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
                        formControlName="transportRoute" class="ng-select control role-select">

                    </ng-select>


                    <app-error-message [form]="form" controlName="transportRoute"
                        [showErrorMessage]="showErrorMessages"></app-error-message>

                </div>
            </div>

        </div>

        <div class="modal-actions-wrapper">
            <button type="submit" class="custom-btn-primary w-100" [disabled]="
            !form.dirty || form.invalid || isSubmitting
          ">
                <ng-container *ngIf="!isSubmitting; else loadingTemplate">
                    <span>Save & Continue</span>
                </ng-container>
                <ng-template #loadingTemplate>
                    <span>Saving, please wait...</span>
                    <div class="spinner-light"></div>
                </ng-template>
            </button>
        </div>
    </form>
</div>